export const body = {
    textAlign: "center"
};

export const bottomStyle = {
    backgroundColor: "#163172",
    color: "white",
    padding: "10px",
    textAlign: "left",
    paddingLeft: "5%",
    paddingRight: "5%",
    paddingBottom: "20px"
};

export const linkText = {
    cursor: "pointer",
    textDecoration: "underline"
};

export const imageSize = {
    width: "156px",
    height: "150px"
};
